export default "__VITE_ASSET__DTI9bUH___"